<template>
  <div class="d-flex py-2 align-items-center">
    <span
      class="document__name__status col-6 d-flex flex-column flex-md-row align-items-center"
    >
      <span class="document-name body-strong text-grey-900 col-12">
        {{ displayName }}
      </span>
      <span class="document-status caption text-grey-900 col-12">
        {{ t(`documents.${document.documentType}-available`) }}
      </span>
    </span>
    <a
      class="document-download d-flex align-items-center gap-1 col-6 link-small justify-content-end"
      :class="isAvailable ? 'cursor-pointer' : 'disabled'"
      :href="props.document.fileLink || '#'"
      target="_blank"
    >
      <span v-if="isAvailable" class="download-text">{{ t('documents.download') }}</span>
      <div class="download-icon">
        <DownloadIcon />
      </div>
    </a>
  </div>
</template>

<script lang="ts" setup>
  import { computed, ComputedRef } from 'vue'

  // Types
  import { Document } from '@/services/DocumentsService.interface'

  // Icons
  import DownloadIcon from '@/assets/DownloadIcon.vue'

  // Translations
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()

  // Props
  interface Props {
    document: Partial<Document>
  }

  const props = defineProps<Props>()

  // Computed
  const isAvailable: ComputedRef<boolean> = computed(() => {
    return !!props.document.fileLink
  })

  // Display name: use label for "other" type, otherwise use translated document type
  const displayName: ComputedRef<string> = computed(() => {
    if (props.document.documentType === 'other' && props.document.label) {
      return props.document.label
    }
    return t(`documents.${props.document.documentType}`)
  })
</script>

<style scoped>
  .document-download.disabled {
    color: var(--grey-400);
    pointer-events: none;
  }
</style>
